import React, { useState, useEffect, Fragment } from "react";
import AdminDashboard from "../../AdminDashboard";
import { dict } from "../../../../dictionary";
import { default_url } from "../../../..";
import { isAuthenticated } from "../../../../auth";
import { deleteCoupon } from "../../apiAdmin"
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import { listCoupons, listProductsByFilters } from "../../../apiCore";
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'


function CouponsAdmin() {
    const [data, setData] = useState([]);
    const [active, setActive] = useState(false);
    const [deletedItem, setDeletedItem] = useState({
        name: "",
        id: "",
        success: false
    });
    const [show, setShow] = useState(false);

    const { user, token } = isAuthenticated();

    const loadCoupons = () => {
        listCoupons().then(res => {
            if (res.error) {
                console.log(res.error);
            } else {
                setData(res);
            }
        });
    }

    useEffect(() => {
        loadCoupons();
    }, [])

    const handleClose = () => {
        setShow(false);
    }
    const handleShow = (event) => {
        setShow(true);
        setDeletedItem({ name: event.target.name, id: event.target.id })
    }
    const handleDelete = (event) => {
        event.preventDefault();
        handleClose();
        deleteCoupon(deletedItem.id, user._id, token).then(res => {
            if (res.error) {
                console.log(res.error);
            } else {
                loadCoupons();
                setDeletedItem({ ...deletedItem, success: true });
            }
        })
    }

    const clickSubmit = () => {
        window.location.href = default_url + "admin/coupons/add"
    }

    const popUp = () => {
        return (
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{dict["deleting_coupon"]}</Modal.Title>
                </Modal.Header>
                {
                    default_url == "/en/" && <Modal.Body style={{ textAlign: "start" }}>{"Are you sure you want to delete Coupon" + deletedItem.name }</Modal.Body>
                }
                {
                    default_url == "/ar/" && <Modal.Body style={{ textAlign: "start" }}>{"هل انت متأكد تريد حذف الكوبون " + deletedItem.name }</Modal.Body>
                }
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        {dict["close"]}
                    </Button>
                    <Button variant="primary" onClick={handleDelete}>
                        {dict["delete"]}
                    </Button>
                </Modal.Footer>
            </Modal>
        )
    }

    const showAlert = () => {
        if (deletedItem.success) {
            return (
                <div
                    className={"alert alert-info alert-dismissible fade show"}
                    role="alert"
                >
                    <h2 style={{ textAlign: "start" }}>{dict["coupon_has_been_deleted"]}</h2>
                    <button type="button" className="close alertCloseBtn" data-dismiss="alert" aria-label="Close" style={{ left: default_url == "/ar/" ? "0" : "auto", right: default_url == "/ar/" ? "auto" : "0" }}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            )
        }
    }

    const allCoupons = () => {
        return (
            data.map((item, index) => {
                return (
                    <div key={index} className={"dataContainer " + (index === data.length - 1 ? "lastDataContainer" : "")}>
                        <span className="dataContainerNumber" style={{ float: default_url == "/en/" ? "left" : "right" }}>{index + 1}</span>
                        <span className="dataContainerTitle" style={{ float: default_url == "/en/" ? "left" : "right", width: "320px"}}>{dict['coupon_code'] +": " + item.code}</span>
                        <span className="dataContainerTitle" style={{ float: default_url == "/en/" ? "left" : "right", width: "150px" }}>{dict['type'] + ": " + dict[item.type]}</span>
                        <span className="dataContainerTitle" style={{ float: default_url == "/en/" ? "left" : "right", width: "100px" }}>{dict['amount'] + ": " + (item.amount ? item.amount : "-")}</span>
                        <span className="dataContainerTitle" style={{ float: default_url == "/en/" ? "left" : "right", width: "175px" }}>{dict['requires_signin'] + ": " + (item.requiresSignin ? dict['yes'] : dict['no'])}</span>
                        <span className="dataContainerTitle" style={{ float: default_url == "/en/" ? "left" : "right", width: "150px" }}>{dict['how_often_used'] + ": " + item.usedTimes}</span>
                        <span className="dataContainerTitle" style={{ float: default_url == "/en/" ? "left" : "right", width: "150px" }}>{dict['active'] + ": " + (item.active ? dict['yes'] : dict['no'])}</span>
                        <a className="dataContainerAction"
                            href="#"
                            onClick={handleShow}
                            name={item.code}
                            id={item._id}
                            style={{ float: default_url == "/en/" ? "right" : "left" }}
                        >{dict["delete"]}</a>
                        {popUp()}
                        <a className="dataContainerAction" href={default_url + "admin/coupons/edit?coupon_id=" + item._id}  style={{float: default_url == "/en/" ? "right": "left"}}>{dict["edit"]}</a>
                    </div>
                )
            })
        )
    }

    const showEmpty = () => {
        return (
            <h1 style={{ textAlign: "start" }}>{dict["no_coupons_found"]}</h1>
        )
    }

    const form = () => {
        return (
            <div className="userProfileDataContainer">
                {showAlert()}
                <h3 className="formContainerTitle">{dict["coupons_list"]}</h3>
                {data.length > 0 ? allCoupons() : showEmpty()}
                <button onClick={clickSubmit} type="submit" className="dashboardBtn">{dict["add_new_coupon"]}</button>
            </div>
        )
    }

    return (
        <AdminDashboard
            active="9"
            data={form}
            categories={[]}
            subcategories={[]}
            newOrders={0}
        />
    )
}

export default CouponsAdmin;